// extracted by mini-css-extract-plugin
export var root = "MarkdownUL-module--root--74925";